import styled from 'styled-components'
import { StyledType } from 'ui/components/TaskTypeBadge/styled'

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
`

export const TitleWrap = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;

  ${StyledType} {
    margin: 0;
    align-self: start;
  }
`

export const Title = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: var(--t-text-primary);
  overflow-wrap: anywhere;
  word-break: break-word;
`

export const Right = styled.div`
  display: flex;
  gap: 12px;
`
